<template>
  <PageWrap :page-title="pageTitle">
    <LoadingIndicator
      v-if="loadingData"
      class="mt-5"
    />

    <template v-else>
      <b-row>
        <b-col>
          <b-row class="mb-3">
            <b-col cols="12">
            </b-col>
            <b-col cols="12">
              <JobForm
                :data="formData"
                :editing="isEditing"
                @update="updateForm"
                :errors="formErrors"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <BfButton v-if="!isEditing" class="mr-3" @click="createJob">Guardar</BfButton>
      <BfButton
        v-if="isEditing"
        variant="red"
        @click="showDeleteModal"
      >
        Eliminar
      </BfButton>

      <DeleteWarningModal
        v-model="displayDeleteModal"
        title="¿Desea eliminar este tipo de trabajo?"
        @confirm-deletion="deleteJob"
      />
    </template>
  </PageWrap>
</template>

<script>
import JobForm from '@/components/FormGroups/JobForm';
import BranchForm from '@/components/FormGroups/BranchForm';
import FormSectionHeader from '@/components/FormSectionHeader';
import LoadingIndicator from '@/components/LoadingIndicator';
import DeleteWarningModal from '@/components/DeleteWarningModal';
import PageWrap from '@/components/PageWrap';

import { jobAPI } from '@/api';

export default {
  name: 'JobsDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    return {
      formData: {},
      formErrors: {},
      loadingData: false,
      displayDeleteModal: false,
    };
  },

  async created() {
    this.loadingData = true;

    try {
      if (this.isEditing) {
        await this.loadData();
      } else {
        await this.prepareForm();
      }
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async loadData() {
      const {
        data: [jobData],
      } = await jobAPI.get(this.id);

      this.formData = jobData;
    },

    async prepareForm() {
      const { data } = await jobAPI.preCreate();
      this.formData = data;
    },

    async updateForm({ key, value }) {
      const newData = { [key]: value };

      if (!this.isEditing) {
        this.formData = { ...this.formData, ...newData };
      } else {
        this.formErrors = {};

        try {
          const { data, message } = await jobAPI.update({
            id: this.id,
            data: newData,
          });

          this.formData = data;
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
        } catch ({ errors }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message: 'Existe un error con tus datos',
            type: 'error',
          });
        }
      }
    },

    async createJob() {
      try {
        this.formErrors = {};
        const { data, message } = await jobAPI.create(this.formData);

        this.$bfNotify({ title: 'Guardado', message, type: 'success' });
        this.$router.replace({ name: 'job', params: { id: `${data.id}` } });
      } catch ({ errors, message }) {
        this.formErrors = errors;
        this.$bfNotify({ title: 'Error', message: 'Existe un error con tus datos', type: 'error' });
      }
    },

    async deleteJob() {
      try {
        const { message } = await jobAPI.delete(this.id);

        this.$bfNotify({ title: 'Eliminado', message, type: 'success' });
        this.$router.replace({ name: 'jobs' });
      } catch ({ message }) {
        this.$bfNotify({ title: 'Error', message, type: 'error' });
      }
    },
    async showDeleteModal() {
      this.displayDeleteModal = true;
    },
  },

  computed: {
    isEditing() {
      return !!this.id;
    },

    pageTitle() {
      return this.isEditing
        ? `Tipo de trabajo: ${this.formData.clave || ''}`
        : 'Crear Tipo de trabajo';
    },
  },

  components: {
    JobForm,
    BranchForm,
    DeleteWarningModal,
    FormSectionHeader,
    LoadingIndicator,
    PageWrap,
  },
};
</script>
